module.exports = __webpack_public_path__ + "static/media/screen2.051034e6.png";